import { useState } from "react";
import ErrorBoundary from "@/components/shared/ErrorBoundary";
import FakturaTab from "@/components/project/FakturaTab";
import { ManualRevenueSection } from "@/components/project/ManualRevenueSection";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";
import type { InvoicePrefill } from "@/components/project/CreateInvoiceForm";

export default function FakturaPage() {
  const { project, invoices, customer } = useProjectDetailContext();
  const [showCreateInvoice, setShowCreateInvoice] = useState(false);
  const [invoicePrefill, setInvoicePrefill] = useState<InvoicePrefill | null>(null);

  return (
    <ErrorBoundary>
      <div className="space-y-4">
        <FakturaTab
          project={project}
          invoices={invoices}
          customer={customer}
          showCreateInvoice={showCreateInvoice}
          invoicePrefill={invoicePrefill}
          onOpenCreate={(prefill) => {
            setInvoicePrefill(prefill ?? null);
            setShowCreateInvoice(true);
          }}
          onCloseCreate={() => {
            setShowCreateInvoice(false);
            setInvoicePrefill(null);
          }}
        />
        {/* VIB-792: superadmin-registrering av inntekt uten PO-faktura */}
        <ManualRevenueSection project={project} invoices={invoices} />
      </div>
    </ErrorBoundary>
  );
}
